<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.clientName') }}</label>
        <div>
          <input v-model="model.client_name" type="text" class="form-control" />
          <div class="validate" v-if="errors.has('client_name')">
            {{ errors.first('client_name') }}
          </div>
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{
          $t('task.mobileNumber')
        }}</label>
        <div>
          <input
            v-model="model.client_mobile_number"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('client_mobile_number')">
            {{ errors.first('client_mobile_number') }}
          </div>
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.address') }}</label>
        <div>
          <textarea
            v-model="model.client_address"
            rows="1"
            class="form-control"
          ></textarea>
          <div class="validate" v-if="errors.has('client_address')">
            {{ errors.first('client_address') }}
          </div>
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.remark') }}</label>
        <div>
          <textarea
            v-model="model.remarks"
            rows="6"
            class="form-control"
          ></textarea>
          <div class="validate" v-if="errors.has('remarks')">
            {{ errors.first('remarks') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },

  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
